import { allDictItems, deleteDictItem, saveOrUpdateDictItem } from '@/utils/request'
import vue from '@/main'

const state = {
  itemList: []
}

const mutations = {
  RESET (state) {
    state.itemList = []
  },
  ADD (state, { value, code, type }) {
    for (const item of state.itemList) {
      if (item.type === type) {
        if (!item.elements) item.elements = []
        item.elements.push({
          value,
          type,
          code
        })
        break
      }
    }
  },
  REMOVE (state, { index, type }) {
    for (const item of state.itemList) {
      if (item.type === type) {
        item.elements.splice(index, 1)
        break
      }
    }
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allDictItems().then(response => {
        state.itemList = []
        for (const item of response.data) {
          state.itemList.push({
            type: item.first,
            elements: item.second
          })
        }
        resolve(state.itemList)
      })
    })
  },
  saveOrUpdate ({ state }, { id, value, code, type, index }) {
    return new Promise((resolve) => {
      saveOrUpdateDictItem({
        id,
        value,
        code,
        type
      }).then(response => {
        for (const item of state.itemList) {
          if (item.type === type) {
            vue.$set(item.elements, index, response.data)
            break
          }
        }
        this.dispatch('data/kvListForce', type)
        resolve()
      })
    })
  },
  delete ({ commit, dispatch, state }, { id, type }) {
    return new Promise((resolve) => {
      deleteDictItem(id).then(() => {
        for (const item of state.itemList) {
          if (item.type === type) {
            for (const i in item.elements) {
              if (item.elements[i].id === id) {
                item.elements.splice(i, 1)
                break
              }
            }
            break
          }
        }

        this.dispatch('data/kvListForce', type)
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
